import React from 'react'
import paint from "../../../images/students/brush.png"
import brush from "../../../images/students/paint-icon.svg"
import card from "../../../images/students/card-icon.svg"
import cash from "../../../images/students/cash-icon.svg"
import heart from "../../../images/students/heart-cion.svg"
import { LuShield } from 'react-icons/lu'


export default function Price() {
    return (
        <div className='mb-[20px] sm:mb-[50px] xl:mb-[70px] p-[20px] md:p-[40px] relative z-0 w-full overflow-hidden text-center bg-[#F0FDF4]'>
            <p className='text-[#101828] font-semibold text-[24px] md:text-[48px]'><span className='bg-[#34C759] px-[12px] md:px-[26px] py-[5px] rounded-[12px] md:rounded-[20px] text-[#FFFFFF] font-bold text-[26px] md:text-[60px]'>₹499</span> for the full four week program</p>
            <p className='mt-[6px] text-[#4A5565] font-medium text-[16px] md:text-[25px]'>One price. No hidden fees.</p>
            <div className='md:w-10/12 mx-auto bg-[#F9FAFB] rounded-[24px] p-[20px] md:p-[32px] mt-[20px] md:mt-[48px]' style={{ boxShadow: "0px 0px 10px 0px #00000026" }}>
                <div className='relative text-[#F9FAFB] font-semibold text-[22px] md:text-[51px] mx-auto'>
                    <p className='relative z-10'>Why ₹499?</p>
                    <img src={paint} alt='paint' loading='lazy' className='absolute z-0 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2' />
                </div>
                <div className='flex flex-wrap gap-[32px] justify-start md:justify-center items-center mt-[24px] text-[#000000] text-[18px] md:text-[24px] font-medium text-start'>
                    <div className='flex gap-[5px] md:gap-[10px] items-center'>
                        <img src={brush} alt='brush' loading='lazy' className='w-[22px] md:w-auto flex-shrink-0' />
                        <p>Creates commitment</p>
                    </div>
                    <div className='flex gap-[5px] md:gap-[10px] items-center'>
                        <img src={card} alt='card' loading='lazy' className='w-[22px] md:w-auto flex-shrink-0' />
                        <p>Keeps access fair and inclusive</p>
                    </div>
                    <div className='flex gap-[5px] md:gap-[10px] items-center'>
                        <img src={cash} alt='cash' loading='lazy' className='w-[22px] md:w-auto flex-shrink-0' />
                        <p>Covers operational costs only</p>
                    </div>
                    <div className='flex gap-[5px] md:gap-[10px] items-center'>
                        <img src={heart} alt='heart' loading='lazy' className='w-[22px] md:w-auto flex-shrink-0' />
                        <p>Workfast AI is our business revenue; Surge is our social mission.</p>
                    </div>
                </div>
            </div>
            <div className='md:w-9/12 mx-auto mt-[20px] md:mt-[48px] pt-[20px] md:pt-[40px] border-t border-[#D6D6D6]'>
                <div className='bg-[#E1F1FF] flex gap-[10px] md:gap-[20px] items-center justify-center md:w-[600px] mx-auto rounded-[12px] md:rounded-[20px] p-[10px] md:px-0 md:py-[17px] text-[#008AEC] text-start text-[14px] md:text-[24px] font-semibold'>
                    <LuShield className='flex-shrink-0' />
                    <p>100% student first 7 day refund guarantee</p>
                </div>
                <p className='mt-[12px] md:mt-[25px] text-[#6A7282] font-normal text-[14px] md:text-[22px]'>Simple process, no questions asked.</p>
            </div>
            <button className='mt-[20px] md:mt-[48px] w-full md:w-[450px] h-[40px] md:h-[60px] lg:h-[70px] rounded-[12px] md:rounded-[18px] bg-[#34C759] font-semibold text-[#FFFFFF] text-[20px] md:text-[25px]'
                onClick={() => {
                    const slotDiv = document.getElementById("slot");
                    if (slotDiv) {
                        slotDiv.scrollIntoView({ behavior: "smooth", block: "start" });
                    }
                }}
            >Join now ₹499</button>
        </div>
    )
}
